<template>
  <oie-interactive-list-item class="machine-item">
    <template #media>
      <img
        v-if="profileImageUrl"
        :src="`${profileImageUrl}?preset=ProductThumb`"
        :alt-text="machine.name">
      <oie-base-icon v-else icon="machine" size="l"></oie-base-icon>
    </template>
    <template #content>
      <button class="h3 machine-item__name" @click.stop="$emit('select-machine', machine)">
        {{ machine.name }}
      </button>
      <div class="machine-item__details">
        <template>
          <p>{{ vehicleIdDictionary[machine.type] || '' }}</p>
          <oie-base-dot></oie-base-dot>
        </template>
        <template>
          <p>{{ vehicleIdDictionary[machine.manufacturer] || '' }}</p>
          <oie-base-dot></oie-base-dot>
        </template>
        <p>
          {{ vehicleIdDictionary[machine.model] || '' }}
        </p>
      </div>
    </template>
    <template v-if="hasActions" #actions>
      <slot name="actions"></slot>
    </template>
  </oie-interactive-list-item>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    machine: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('myMachines', ['vehicleIdDictionary']),
    profileImageUrl() {
      const profileImage = _.find(this.machine.images, img => img.type === 'profile')
      return profileImage && profileImage.url
    },
    hasActions() {
      return this.$slots.actions || this.$scopedSlots.actions
    }
  }
}

</script>

<style lang="scss">
.machine-item:hover {
  background-color: color(blue-5);

  .machine-item__name {
    text-decoration: underline;
  }
}

.machine-item__name {
  @include reset-button;
}

.machine-item__name::after {
  content: "";
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
}

.machine-item__details {
  @include caption;
  color: color(gray-2);
  display: flex;
  align-items: center;
}

.machine-item__details >*:not(:last-child) {
  margin-right: measure(quarter);
}

</style>
